import {
  UPDATE_DISPLAY_FOOTER,
  UPDATE_DISPLAY_HEADER,
} from "../../action-types";

const initialState = {
  //是否显示页脚
  displayFooter: true,
  // 是否显示页头
  displayHeader: true,
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DISPLAY_FOOTER:
      //是否显示页脚, true-显示，false-不显示
      return {
        ...state,
        displayFooter: action.payload,
      };
    case UPDATE_DISPLAY_HEADER:
      //是否显示页头, true-显示，false-不显示
      return {
        ...state,
        displayHeader: action.payload,
      };
    default:
      return state;
  }
};

export default layoutReducer;
